import "./styles.scss"

const DataEmpty = () => {
  return <div className="data-empty-container">No Data</div>
}

export default DataEmpty
